/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVR4nN2VvUrEQBDHF7849DUU4bC1DghXXWZmI2xmBCHY5AV8gJRG7C3tzwdQX8LOXgs9BFutDj/YI1FJciGfhQ78ITCZ/29nZ5NV6t+EMWYNNZ8C8RS1fDYRaH5CLbH1ygFsoqkx5hXnAAn9ZzXEUyB+T1SrK+tV1MGvF+TecZwVALNpFYbhKhI/1IGUApB4kssTT7oBkFw5QTDI5p0gGCDxda8A0HzT4xbJZWczsEO2gx3vH2xZdT/kufg5Pab2ue63UAGwQCS3oDlELWeoZdYxgO9Go8ONtAa0BG0BH6jlLTF/RTTDbB1ouWg6g5ex5+8YY5aR5NyuNleklHJdd912VhcwA0/20lwURUtF5t+1aIbzDisfU5LjMsOiQPSPKgNcz99VNQPRbJcCsr/rlnrs9cIBkpMFV6bEbTqBsivzz8YXPdJ1gHiNk4EAAAAASUVORK5CYII=)
 */
export const ImageIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm13.35 8.13 3.5 4.67c.37.5.02 1.2-.6 1.2H5.81a.75.75 0 0 1-.59-1.22l1.86-2.32a1.5 1.5 0 0 1 2.34 0l.5.64 2.23-2.97a2 2 0 0 1 3.2 0ZM10.2 5.98c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
